module.exports = __webpack_public_path__ + "img/web-leads.su2.b7c78bbb.svg";